import React from 'react';
import PropTypes from 'prop-types';
const GoogleMapsFactory = ({
  mapRef
}) => /*#__PURE__*/React.createElement("div", {
  className: `google-maps ${!mapRef ? 'loading' : ''}`,
  ref: mapRef
});
GoogleMapsFactory.propTypes = {
  mapRef: PropTypes.object
};
GoogleMapsFactory.defaultProps = {
  mapRef: null
};
export default GoogleMapsFactory;
//# sourceMappingURL=GoogleMapsHtml.js.map